import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pagination } from "@mui/material";
import { Flex } from "@100mslive/roomkit-react";
import FullPageProgress from "../../FullPageProgress";
import { ToastManager } from "../../Toast/ToastManager";
import WatchListItem from "./WatchListItem";
import MyOrgTop from "./WatchlistTop";
import { SESSION_AUTH } from "../../../common/auth";
import { WATCHLIST_SERVICES } from "../../../services";

const Watchlist = () => {
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const navigate = useNavigate();
  const [userData, setUserData] = useState("");
  const [listData, setDataList] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (isUserSession) {
      setUserData(isUserSession);
    } else {
      setUserData("");
      navigate("/");
    }
  }, [isUserSession, navigate]);

  useEffect(() => {
    if (!userData || dataFetched) return;
    setDataFetched(true);
    setLoading(true);
    WATCHLIST_SERVICES.getWatchList({
      userId: userData.userId,
      org: userData?.org?.id,
      page: page,
    })
      .then(data => {
        if (data.code === 200) {
          setDataList(data?.data?.list);
          if (data.data?.pageInfo?.page === 1) {
            setTotalPage(data.data?.pageInfo?.totalPage || 0);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataFetched, userData, page, LOGOUT_USER_SESSION]);

  const handleWatching = async accountId => {
    setLoading(true);
    try {
      const data = await WATCHLIST_SERVICES.action({
        userId: isUserSession?.userId,
        org: isUserSession?.org?.id,
        type: "remove",
        id: accountId,
      });
      if (data.code === 200) {
        setPage(1);
        setDataFetched(false);
      } else if (data.code === 600) {
        LOGOUT_USER_SESSION();
      } else {
        ToastManager.addToast({ title: data.message });
      }
    } catch (error) {
      ToastManager.addToast({ title: error.message });
    }
    setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    if (page === newPage) return;
    setPage(newPage);
    setDataFetched(false);
  };

  return (
    <React.Fragment>
      <div className="events6ix-layout-page-middle">
        <MyOrgTop />

        <div className="events-page-myorg-content">
          <div className="events-page-myorg-content-row">
            {listData?.length > 0 ? (
              <>
                {listData.map((org, key) => {
                  return (
                    <WatchListItem
                      handleWatching={handleWatching}
                      orgItem={org}
                      key={key}
                    />
                  );
                })}
              </>
            ) : !loading ? (
              <div className="event-page-explore-content-empty">
                Watchlist not found, try again.
              </div>
            ) : null}
          </div>
          {totalPage > 1 && (
            <Flex justify="center" className="text-center mt-20">
              <Pagination
                variant="text"
                onChange={handleChangePage}
                page={page}
                count={totalPage}
              />
            </Flex>
          )}
          {loading ? <FullPageProgress fixed={true} /> : null}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Watchlist;
